export const TEAM = '/team';
